export default registerDataConfig;

/** @ngInject */
function registerDataConfig($stateProvider, modulesProvider) {
  modulesProvider.registerModule({
    title: 'Rejestr danych osobowych',
    state: 'modules.registerData',
    showInMenu: true,
    permissions: ['MANAGER']
  });

  $stateProvider.state('modules.registerData', {
    url: '/register-data',
    views: {
      'content@': {
        component: 'registerDataComponent'
      }
    },
    resolve: {
      me: SchoolCommonRoomService => SchoolCommonRoomService.getMe()
    }
  });
}
